/**
 * @file   banner图
 * @create zhangchen 2020/11/06
 * @update zhangchen 2020/11/12 修改banner图地址
 */

import React from 'react';
import { useRoutesMap } from '@portal-site/core';
import { useLocation } from 'react-router-dom';
import Breadcrumb from '../Bread';
import MyLink from '../../../components/MyLink';
import defaultImg from '@/assets/images/desktop/common/innerbanner.jpg';

const InnerBanner = function() {
  const assetsPrefix = window.ENV_IMG_PREURL;
  const routes = useRoutesMap();
  const routesMap = useRoutesMap().flatToObject();
  const { pathname } = useLocation();
  const path = pathname.split('/');
  const imgSrc = routes.children.find((item) => item.route === path[1])?.imgSrc;
  const bannerImg = imgSrc ? `${assetsPrefix}${imgSrc}` : defaultImg;
  const bannerName = routes.children.find((item) => item.route === path[1])?.name;
  return (
    <div className="inner-banner">
      <img src={bannerImg} alt="" />
      <div className="allcenter">
        <Breadcrumb />
        <div className="name">
          <div className="fsname">{bannerName}</div>
          {Object.keys(routesMap).length > 0 &&
            routesMap &&
            routesMap[path[1]].children.length > 0 && (
              <ul className="menu">
                {routesMap[path[1]].children?.map((item) => {
                  return (
                    <li key={item.id} className={item.route === path[2] ? 'active' : ''}>
                      <MyLink
                        to={`/${path[1]}/${item.route}`}
                        linkUrl={item.url === '/' ? '' : item.url}
                      >
                        {item.name}
                      </MyLink>
                    </li>
                  );
                })}
              </ul>
            )}
        </div>
      </div>
    </div>
  );
};

export default InnerBanner;
